import React from 'react'
import PropTypes from 'prop-types'
import CheckmarkIcon from '@bufferapp/ui/Icon/Icons/Checkmark'

import { Dialog } from '~/shared/components'
import { IconWrapper } from './styles'

/**
 *
 */
// @ts-expect-error TS(7031) FIXME: Binding element 'onSubmit' implicitly has an 'any'... Remove this comment to see the full error message
const DismissWarning = ({ onSubmit, onCancel }) => (
  <Dialog
    withDontShowAgain
    cancel={{ label: 'Cancel', handler: onCancel }}
    submit={{ label: 'Dismiss Comment', handler: onSubmit }}
  >
    <Dialog.Title>You don't have to reply to everything! 😅</Dialog.Title>
    <Dialog.Message>
      If you'd rather dismiss a comment simply click on the
      <IconWrapper>
        <CheckmarkIcon size="medium" />
      </IconWrapper>
      icon or hit Ctrl + D on your keyboard.
    </Dialog.Message>
  </Dialog>
)

DismissWarning.propTypes = {
  onSubmit: PropTypes.func.isRequired,
  onCancel: PropTypes.func.isRequired,
}

export default DismissWarning
